import { useEffect } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { useMap } from "react-leaflet";

export const TILE = "https://tile.openstreetmap.org/{z}/{x}/{y}.png";
export const ATTR = '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>';
export const BANDA = { Bajo: "#2F7D4F", Medio: "#D9A53B", Alto: "#E8643C", "Muy alto": "#9F1F14" };
export const BandChip = ({ b, testid }) => (b ? <span data-testid={testid} className="inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-bold text-white" style={{ background: BANDA[b] }}>{b}</span> : <span className="text-xs text-[#8C867A]">n.d.</span>);
const STOPS = [[0, [243, 239, 232]], [35, [240, 205, 160]], [60, [232, 100, 60]], [100, [120, 22, 14]]];
export const colorIdx = (v) => {
  if (v == null) return "#E2DDD5";
  const i = STOPS.findIndex(([s]) => v <= s);
  const [s1, c1] = STOPS[Math.max(0, i - 1)];
  const [s2, c2] = STOPS[Math.max(0, i)];
  const t = s2 === s1 ? 0 : (v - s1) / (s2 - s1);
  return `rgb(${c1.map((c, k) => Math.round(c + (c2[k] - c) * t)).join(",")})`;
};
export const fmt = (n, d = 2) => (n == null ? "n.d." : Number(n).toLocaleString("es-MX", { maximumFractionDigits: d }));
export const tipHtml = (row, labels) => {
  if (!row) return "<b>Sin datos</b>";
  const ind = Object.entries(labels).map(([k, l]) => {
    const x = row.ind?.[k];
    return x ? `<div style="display:flex;justify-content:space-between;gap:12px"><span>${l}</span><b>${fmt(x.valor)} ${x.unidad?.startsWith("por") ? "/100k" : x.unidad || ""}</b></div>` : "";
  }).join("");
  const any = Object.values(row.ind || {})[0];
  return `<div style="min-width:220px;font-family:inherit"><div style="font-weight:700;font-size:13px">${row.nombre}</div>
    <div style="margin:4px 0 6px">Índice <b>${fmt(row.indice, 1)}</b>/100 · ${row.banda || "n.d."}</div>${ind}
    ${any ? `<div style="margin-top:6px;color:#8C867A;font-size:11px">${any.fuente?.split(" · ")[0]} · corte ${any.corte || "n.d."}</div>` : ""}</div>`;
};

export const FitTo = ({ data, points }) => {
  const map = useMap();
  useEffect(() => {
    try {
      if (data) map.fitBounds(L.geoJSON(data).getBounds(), { padding: [12, 12] });
      else if (points?.length === 1) map.setView(points[0], 13);
      else if (points?.length) map.fitBounds(L.latLngBounds(points), { padding: [30, 30], maxZoom: 13 });
    } catch { /* geometría vacía */ }
  }, [data, points, map]); // eslint-disable-line react-hooks/exhaustive-deps
  return null;
};

export const Legend = () => (
  <div className="flex items-center gap-2 text-[11px] text-[#5C5850]" data-testid="mapa-leyenda">
    <span>Bajo</span><span className="h-2 w-28 rounded-full" style={{ background: `linear-gradient(90deg, ${[0, 35, 60, 100].map(colorIdx).join(",")})` }} /><span>Muy alto</span>
  </div>
);
